import * as React from 'react';

import styles from './feedback-page-container.module.css';

type Props = {
    children: React.ReactNode;
};

export function FeedbackPageContainer(props: Props) {
    return <div className={styles['feedback-page']}>{props.children}</div>;
}
